// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3b729bcc","inlineWrapper":"_6a2775a5","star":"_1dcec20b","small":"_43c9cf40","medium":"_ffb71962","large":"_2d69e9e2","xSmall":"_6563e538","selectable":"_eca424fd"};